import { updateObject } from "utils";

function reducer(state, action) {
  switch (action.type) {
    case "OPEN_POPUP":
      return updateObject(state, {
        popup: updateObject(state.popup, {
          show: true,
          alertName: action.alertName,
          params: action.params
        })
      });
    case "CLOSE_POPUP":
      return updateObject(state, {
        popup: updateObject(state.popup, {
          show: false,
          alertName: ""
        })
      });
    case "UPDATE_POPUP_PARAMS":
      return updateObject(state, {
        popup: updateObject(state.popup, {
          params: updateObject(state.popup.params, {
            ...action.params
          })
        })
      });
    case "OPEN_SLIDING_POPUP":
      return updateObject(state, {
        slidingPopup: updateObject(state.slidingPopup, {
          show: true,
          tab: action.tab,
          alertName: action.alertName,
          params: action.params
        })
      });
    case "CLOSE_SLIDING_POPUP":
      return updateObject(state, {
        slidingPopup: updateObject(state.slidingPopup, {
          show: false,
          uuid: null,
          editSource: false
        })
      });
    case "SWITCH_SLIDING_POPUP":
      return updateObject(state, {
        slidingPopup: updateObject(state.slidingPopup, {
          show: true,
          tab: action.tab,
          alertName: action.alertName,
          params: action.params
        })
      });
    case "OPEN_SLIDER_POPUP":
      return updateObject(state, {
        slidingPopup: updateObject(state.slidingPopup, {
          popup: updateObject(state.slidingPopup.popup, {
            show: true,
            alertName: action.alertName
          })
        })
      });
    case "CLOSE_SLIDER_POPUP":
      return updateObject(state, {
        slidingPopup: updateObject(state.slidingPopup, {
          popup: updateObject(state.slidingPopup.popup, {
            show: false,
            alertName: ""
          })
        })
      });
    case "TOGGLE_SIDE_BAR":
      return updateObject(state, {
        sidebarCollapse: !state.sidebarCollapse
      });
    case "TOGGLE_BACKUP_STATS":
      return updateObject(state, {
        backupStats: updateObject(state.backupStats, {
          show: !state.backupStats.show
        })
      });
    case "CLOSE_BACKUP_STATS":
      return updateObject(state, {
        backupStats: updateObject(state.backupStats, {
          show: false
        })
      });
    case "DISABLE_POPUP_CONFIRM":
      return updateObject(state, {
        popup: updateObject(state.popup, {
          params: updateObject(state.popup.params, {
            disable: action.disable
          })
        })
      });
    case "DISABLE_LEFT_FOOTER":
      return updateObject(state, {
        popup: updateObject(state.popup, {
          params: updateObject(state.popup.params, {
            disableLeftFooter: {
              disable: action.disable,
              remove: action.remove
            }
          })
        })
      });
    case "TOGGLE_NOTIFICATION_CLASS":
      return updateObject(state, {
        notification: action.toggleShow
      });
    default:
      throw new Error();
  }
}

export default reducer;
